import { render, staticRenderFns } from "./errorSeat.vue?vue&type=template&id=5326308c&"
import script from "./errorSeat.vue?vue&type=script&lang=js&"
export * from "./errorSeat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports